import React from 'react';
import {
  TripMatch, TripMatchStatus,
} from '@marageti/z4-sdk/lib/travel';
import { Chip } from '@mui/material';

// Based on Figma Chart: https://www.figma.com/design/cvcI8T2v5wx19qIKC5p9DP/Traveler?node-id=6994-4601&m=dev
const TripMatchStatusChip = ({ tripMatch, size = undefined }: { tripMatch: TripMatch, size?: 'small' | 'medium' | 'large' }) => {
  const isCompleted = new Date(tripMatch.returnDate) < new Date();

  switch (tripMatch.status) {
    case TripMatchStatus.MatchActive:
    case TripMatchStatus.MatchInactive:
      return (
        <Chip
          size={size}
          label="Planning"
          variant="outlined"
          sx={{
            borderColor: 'success.dark',
          }}
        />
      );

    case TripMatchStatus.MatchPostponed:
      return <Chip size={size} label="Postponed" color="default" />;

    case TripMatchStatus.MatchSold:
      if (isCompleted) {
        return <Chip size={size} label="Completed" color="info" />;
      }
      return <Chip size={size} label="Booked" color="primary" />;

    case TripMatchStatus.MatchSoldCanceled:
    case TripMatchStatus.MatchRefundedCanceled:
      return <Chip size={size} label="Booking Canceled" color="default" />;

    case TripMatchStatus.MatchTravelerCanceled:
    case TripMatchStatus.MatchPartnerCanceled:
      return <Chip size={size} label="Canceled" color="default" />;

    case TripMatchStatus.MatchAccepted:
    case TripMatchStatus.MatchPartnerDeclined:
    case TripMatchStatus.MatchZicassoCanceled:
      return null;

    default:
      return null;
  }
};

export default TripMatchStatusChip;
